import { render, staticRenderFns } from "./AstraTopElementAgreedBonusTableColumn.vue?vue&type=template&id=770d5d93&scoped=true"
import script from "./AstraTopElementAgreedBonusTableColumn.vue?vue&type=script&lang=js"
export * from "./AstraTopElementAgreedBonusTableColumn.vue?vue&type=script&lang=js"
import style0 from "./AstraTopElementAgreedBonusTableColumn.vue?vue&type=style&index=0&id=770d5d93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770d5d93",
  null
  
)

export default component.exports